import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import {
  ParametrosOrdenamientosEntity,
  ServicioOrdenamientosService,
  DatosGeneralesEntity,
  FitlrosOrdenEscritaEntity,
  OrdenEscritaEntity,
  InfoOrdenamientoEntity
} from 'src/app/services/servicio-ordenamientos.service';
import { ImagesService } from 'src/app/services/utils/images.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ServicioEntidadService, EntidadEmpresarialEntity } from 'src/app/services/servicio-entidad.service';
import { ServicioParametroSimensService } from 'src/app/services/servicio-parametro-simens.service';

@Component({
  selector: 'app-reporte-orden-escritas',
  templateUrl: './reporte-orden-escritas.component.html',
  styleUrls: ['./reporte-orden-escritas.component.css']
})
export class ReporteOrdenEscritasComponent implements OnInit {

  parametros: ParametrosOrdenamientosEntity = {} as ParametrosOrdenamientosEntity;
  entidadEmpresarial: EntidadEmpresarialEntity;
  datosGenerales: DatosGeneralesEntity;
  ordenesAgrupadas: OrdenEscritaEntity[][];
  filtros: FitlrosOrdenEscritaEntity;
  infoOrdenamiento: InfoOrdenamientoEntity;
  parametroSimens: any;

  fechaImpresion: string = moment().format('YYYY-MM-DD hh:mm:ss');
  mensajeLoading: string = 'Cargando...';
  mensajeError: string;
  logo: string;

  constructor(private activatedRoute: ActivatedRoute,
    private ordenamientosService: ServicioOrdenamientosService,
    private servicioEntidad: ServicioEntidadService,
    private servicioSimens: ServicioParametroSimensService,
    private servicioImagenes: ImagesService,
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.parametros.codigo = params['codigoBaseDatos'];
      this.parametros.uncoSede = Number(params['uncoSede']);
      this.parametros.uncoLogin = Number(params['uncoLogin']);
      this.parametros.unco = Number(params['uncoAdmision']);
      this.parametros.uncoTransaccion = Number(params['uncoTransaccion']);
      this.parametros.uncoHc = Number(params['uncoHc']);
    });
  }

  ngOnInit() {
  }

  onFiltrosCompletados(filtros: FitlrosOrdenEscritaEntity) {
    this.filtros = filtros;
    this.getLogo();
  }

  async getLogo() {
    try {
      this.logo = '';
      this.mensajeLoading = 'Cargando información del logo entidad ...';
      const response = await this.servicioImagenes.getLogo(this.parametros.codigo);
      response.subscribe((data: any) => {
        this.logo = data.source;
        this.getEntidadEmpresarial();
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenEscritasComponent.getLogo()', err);
        this.onError('Error al obtener información del logo entidad, verifique su conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenEscritasComponent.getLogo()', e);
      this.onError('Error grave al obtener información del logo entidad, intente de nuevo o reporte caso al administrador.');
    }
  }

  async getEntidadEmpresarial() {
    try {
      this.mensajeLoading = 'Cargando información entidad ...';
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.parametros.codigo, this.parametros.uncoSede);
      response.subscribe((data: EntidadEmpresarialEntity[]) => {
        if (data && data.length > 0) {
          this.entidadEmpresarial = data[0];
          this.getParametrosSimens();
        } else {
          this.onError('No se pudo cargar la información de la entidad empresarial. Por favor verifique los filtros.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenEscritasComponent.getEntidadEmpresarial()', err);
        this.onError('Error al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenEscritasComponent.getEntidadEmpresarial()', e);
      this.onError('Error grave al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  async getParametrosSimens() {
    const response = await this.servicioSimens.getParametroSimensBySede(this.parametros.codigo, this.parametros.uncoSede);
    if (response != null) {
      response.subscribe((data: any) => {
        this.parametroSimens = data;
        this.getDatosGenerales();
      }, (err: HttpErrorResponse) => {
        this.parametroSimens = null;
        this.onError('Error al obtener los parametros simens, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
        console.error('Error getParametrosSimens()', err);
      });
    }
  }

  async getDatosGenerales() {
    try {
      this.mensajeLoading = 'Cargando datos generales ...';
      let response = await this.ordenamientosService.getDatosGenerales(this.parametros);
      response.subscribe((data: object) => {
        const result = data['#result-set-1'];
        if (result && result.length > 0) {
          this.datosGenerales = this.ordenamientosService.getDatosGeneralesEntity(result);
          this.getOrdenesEscritas();
        } else {
          this.onError('Ocurrió un error al cargar la información del afiliado, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
        }
      }, (error) => {
        console.log('Error ReporteOrdenEscritasComponent.getDatosGenerales()', error);
        this.onError('Ocurrió un error al cargar la información del afiliado, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenEscritasComponent.getDatosGenerales()', e);
      this.onError('Error grave al obtener información del afiliado, intente de nuevo o reporte caso al administrador.');
    }
  }

  async getOrdenesEscritas() {
    try {
      this.mensajeLoading = 'Cargando ordenes escritas ...';
      const solicitudes = this.filtros.solicitudes.toString();
      const profesionales = this.filtros.profesionales.toString();

      let response = await this.ordenamientosService.getOrdenesEscritas(this.parametros,
        solicitudes, profesionales);

      response.subscribe((data: object) => {
        const result = data['#result-set-1'];
        if (result && result.length > 0) {
          const ordenes = this.ordenamientosService.getOrdenesEscritasEntity(result);

          this.ordenesAgrupadas = ordenes.reduce((prev, current) => {
            for (let index = 0; index < prev.length; index++) {
              if (prev[index][0]['registroMedico'] === current['registroMedico']) {
                prev[index].push(current);
                return prev;
              }
            }
            prev.push([current]);
            return prev;
          }, []);

          this.getInfoAdicionalOrdenamiento();
        } else {
          this.onError('Lista de órdenes vacias, verifique que existan registros.');
        }
      }, (error) => {
        console.log('Error ReporteOrdenEscritasComponent.getOrdenesEscritas()', error);
        this.onError('Ocurrió un error al cargar la información del afiliado, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenEscritasComponent.getOrdenesEscritas()', e);
      this.onError('Error grave al obtener información del afiliado, intente de nuevo o reporte caso al administrador.');
    }
  }

  async getInfoAdicionalOrdenamiento() {
    try {
      const response = await this.ordenamientosService.getInfoAdicionalOrdenamiento(this.parametros,
        this.filtros.profesionales[0]);

      response.subscribe((data: any) => {
        if (data) {
          this.infoOrdenamiento = this.ordenamientosService.getInfoOrdenamientoEntity(data);
          this.mensajeLoading = null;
          this.mensajeError = null;
        } else {
          this.onError('No se pudo cargar la información de la orden de servicios. Por favor verifique los filtros.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenServiciosComponent.getInfoAdicionalOrdenamiento()', err);
        this.onError('Error al obtener información de la orden de servicios, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenServiciosComponent.getInfoAdicionalOrdenamiento()', e);
      this.onError('Error grave al obtener información de la orden de servicios, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  onErrorGenerado(mensajeError: string) {
    this.mensajeError = mensajeError;
  }

  onError(msj) {
    this.mensajeLoading = null;
    this.mensajeError = msj;
  }

  isLoading(): boolean {
    return this.mensajeLoading && this.mensajeLoading.length > 0
      && !this.isError();
  }

  isError(): boolean {
    return this.mensajeError && this.mensajeError.length > 0;
  }

  isReady(): boolean {
    return !this.isLoading() && !this.isError();
  }
}
